export const HERO_LAYOUTS = {
  CENTERED: {
    value: "center",
    label: "Centre-aligned text",
  },
  IMAGE_ONLY: {
    value: "image",
    label: "Image only",
  },
  SIDE_SECTION: {
    value: "side",
    label: "Side section",
  },
  FLOATING_SECTION: {
    value: "floating",
    label: "Floating section",
  },
} as const
